var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border-input",class:{
    'add-border' : _vm.addBorder,
    'remove-border': !_vm.addBorder,
    'select-top':_vm.topSelected,
    'select-right':_vm.rightSelected,
    'select-bottom':_vm.bottomSelected,
    'select-left':_vm.leftSelected,
  }},[_c('div',{staticClass:"view"},[_c('div',[_c('div',{staticClass:"view-button top",on:{"click":_vm.topClick}})]),_vm._v(" "),_c('div',[_c('div',{staticClass:"view-button right",on:{"click":_vm.rightClick}})]),_vm._v(" "),_c('div',[_c('div',{staticClass:"view-button bottom",on:{"click":_vm.bottomClick}})]),_vm._v(" "),_c('div',[_c('div',{staticClass:"view-button left",on:{"click":_vm.leftClick}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fff73096","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shell/components/inputs/RxBorderInput.vue
// module id = 92
// module chunks = 0 1